module.exports = __webpack_public_path__ + "img/huan.c8b65c2d.png";